import request from "@/plugins/axios";


export class WorkflowProcess {

  // 获取指定编码类型全部编码列表
  static async groupList() {
    return request.get(`/Crm/WfGroup/WfGroupList`);
  }


//  新增、更新分组
  static addGroup(group) {
    return request.post(`/Crm/WfGroup/SaveWfGroup`, group)
  }

  //  删除分组
  static deleteGroup(id) {
    return request.post(`/Crm/WfGroup/WfGroup?id=${id}`);
  }



  static async list(onelevel= false, enabled, groupId,keyWords) {
    let url = `/Crm/WfDefine/WfDefineList?groupId=${groupId || ''}&enabled=${enabled || ""}`
    if (keyWords) {
      url += `&type=${keyWords}`
    }
    if (onelevel) {
      return request.get(url);
    }
    let groupList = await WorkflowProcess.groupList();
    if (groupList.length) {
      groupList = groupList.map((item) => {
        return Object.assign(item, {List: [],CodeName:item.name})
      });
    }
    const list = await request.get(url)
    let others = [];
    let disables = [];
    list.forEach((item) => {
      if (item.enabled == 1) {
        if (item.groupId) {
          let defGroup = groupList.find((group) => group.id == item.groupId);
          if (defGroup) {
            defGroup.List
                ? defGroup.List.push(item)
                : (defGroup.List = [item]);
          }
        } else {
          others.push(item);
        }
      } else {
        disables.push(item);
      }
    });
    !enabled && groupList.push({
      CodeName: '已停用',
      CodeValue: 'disabled',
      List: disables,
      Type: 'disabled'
    })
    return groupList;
  }


  // 保存流程定义
  static save(model) {
    return request.post(`/Crm/WfDefine/SaveWfDefine`, model);
  }

  //获取流程定义
  static get(id = 0) {
    return request.get(`/Crm/WfDefine/WfDefineInfo?id=${id}`)
  }
  //删除流程定义
  static async remove(id) {
    return request.post(`/Crm/WfDefine/WfDefine/?id=${id}`);
  }

  // 启用流程
  static enable(id, enabled = 1) {
    return request.post(`/Crm/WfDefine/SetWfDefineEnable?id=${id}`,enabled,{
      headers:{
        'Content-Type': 'application/json-patch+json'
      }
    });
  }

  //停用流程
  static async disable(id) {
    return this.enable(id, 0);
  }




}
